import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";


const API_NAME = "formField";

export const formFieldService = {
    getAllUploadsByUserId,
};

function getAllUploadsByUserId(userId?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAllUploadsByUserId/?userId=${userId || ""}`, requestOptions).then(handleResponse);
}
